<template>
  <div>
    <template v-if="['retrieve', 'update'].includes(viewType)">
      <v-skeleton-loader class="mb-5" transition="fade-transition" type="card-heading" />
      <v-skeleton-loader class="mb-5" transition="fade-transition" type="list-item-avatar-three-line" />
      <v-skeleton-loader class="mb-5" transition="fade-transition" type="article" />
      <v-skeleton-loader class="mb-5" transition="fade-transition" type="table" />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    viewType: {
      type: String,
      required: true
    }
  }
}
</script>